import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useAuth } from '@/auth/hooks/useAuth';
import { MyListsPage } from './MyListsPage';
import { ListDetailPage } from './ListDetailPage';
import { CompletedTimelinePage } from './CompletedTimelinePage';

export function TodoListsArchePage() {
  const { isAuthenticated } = useAuth();

  return (
    <ArcheLayout displayMode={isAuthenticated ? 'normal' : 'public'}>
      <Routes>
        <Route path="/" element={<MyListsPage />} />
        <Route path="/:listId" element={<ListDetailPage />} />
        <Route path="/:listId/completed" element={<CompletedTimelinePage />} />
      </Routes>
    </ArcheLayout>
  );
}
